import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./App";
import "aos/dist/aos.css";
import AOS from "aos";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
AOS.init();
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
